import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "left" }}>
            As a <span className="purple">Lead Software Engineer </span>
            with 5+ years of experience, I build scalable backend systems and integrations 
            in cloud-native environments at UPS. I specialize in Kubernetes, GitOps, and modern 
            CI/CD with deep experience in Java-based middleware. I have a Master of Computer Science 
            from University of Louisville and a Bachelor of Science in Computer Science from Indiana 
            University. I focus on modernizing legacy systems, implementing declarative infrastructure, 
            and accelerating developer velocity through automated pipelines. I architect secure, 
            observable, and maintainable distributed systems across OpenShift, Azure, GCP, and AWS.
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
